import React, { useEffect, useState } from "react";
import { Gerenciamento } from "../../../services/Gerenciamento";
import { reverseToBrDate } from "../../../utils/dateTransform";
import {
  IGerenciamentoDTO,
  IGerenciamentoProps,
} from "../../../types/gerenciamento";
import { toast } from "react-toastify";
import { useContextSite } from "../../../context/Context";
import { z } from "zod";
import { useForm, Controller } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { GraphColors } from "../../../utils/graphCorlors";
import dayjs from "dayjs";

const schema = z.object({
  dataInicio: z.string().nullable().optional(),
  dataFim: z.string().nullable().optional(),
  empresa: z.string().min(1).optional().or(z.literal("")),
});

const CidadeOptions = [
  {
    label: "Log",
    value: "Log",
  },
  {
    label: "Starcheck",
    value: "Starcheck",
  },
  {
    label: "Tokyo",
    value: "Tokyo",
  },
  {
    label: "Velox",
    value: "Velox",
  },
];

export const useHome = () => {
  const { setIsLoad } = useContextSite();
  const [dataLinear, setDataLinear] = useState([]);
  const [axisLinear, setAxisLinear] = useState([]);
  const [dataFilter, setDataFilter] = useState<IGerenciamentoProps>({
    dataFim: dayjs(new Date()).format("YYYY-MM-DD"),
    dataInicio: dayjs(new Date()).format("YYYY-MM-DD"),
    empresa: "",
  } as IGerenciamentoProps);

  const [dataGeral, setDataGeral] = useState<IGerenciamentoDTO>(
    {} as IGerenciamentoDTO
  );

  const { control, handleSubmit } = useForm<IGerenciamentoProps>({
    defaultValues: {
      dataFim: dayjs(new Date()).format("YYYY-MM-DD"),
      dataInicio: dayjs(new Date()).format("YYYY-MM-DD"),
      empresa: "",
    },
    mode: "all",
    resolver: zodResolver(schema),
  });

  function getDataGeral(dates: IGerenciamentoProps) {
    setIsLoad(true);

    Gerenciamento.geral(dates)
      .then(({ data }) => {
        formatLineChartData(data.producaoDiaria);
        setDataGeral(data);
      })
      .catch(
        ({
          response: {
            data: { mensagem },
          },
        }) => toast.error(mensagem)
      )
      .finally(() => {
        setIsLoad(false);
      });
  }

  const formatLineChartData = (data) => {
    const dates = [];
    const series = data.map((empresa) => {
      empresa.producao.forEach((producao) => {
        if (!dates.includes(producao.data)) {
          dates.push(producao.data);
        }
      });
      return {
        label: empresa.empresa,
        data: empresa.producao.map((producao) => producao.vistorias),
        color: GraphColors[empresa?.empresa],
      };
    });

    setDataLinear(series);
    setAxisLinear(dates.map(reverseToBrDate));

    return { dates: dates.map(reverseToBrDate), series };
  };

  function handleFilter(data: IGerenciamentoProps) {
    setDataFilter(data);
  }
  useEffect(() => {
    getDataGeral(dataFilter);
  }, [dataFilter]);

  async function downloadExcelReport() {
    setIsLoad(true);

    const url = `${process.env.REACT_APP_BRAVE_API_URL}/gerenciamento/geral/exportar?dataInicio=${dataFilter.dataInicio}&dataFim=${dataFilter.dataFim}&empresa=${dataFilter.empresa}`;

    const filename = "relatorio.xlsx";

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Accept:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        },
      });

      if (!response.ok) {
        toast.info(`Erro ao baixar o relatório: ${response.statusText}`);
      }

      const blob = await response.blob();
      const downloadUrl = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = downloadUrl;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(downloadUrl);
    } catch (error) {
      toast.error("Erro no download do relatório");
    } finally {
      setIsLoad(false);
    }
  }

  return {
    dataGeral,
    dataLinear,
    axisLinear,
    Controller,
    control,
    handleSubmit,
    CidadeOptions,
    GraphColors,
    downloadExcelReport,
    handleFilter,
  };
};
